import { getTenantConfig } from '../utils/tenant';

// Generates a random string with 6 chars. All chars are URL-safe. Yes, this is not the
// most random string ever and we could add a NPM module just for that, but uniqueness is not that
// important here (we pretty much just need that the next string to be different than the previous)
const randomString = () => Math.random().toString(36).substr(2, 6);

// Appends a random string to the end of the URL with a hash fragment. This is an easy way to always
// trigger a reload even when a hash is present, once the default behavior for the browser is to only
// change the fragment but not reload. This is necessary because we are using hash router in React
// Router and sometimes we need to update a URL outside React and still reload the page. By adding
// a random string to the query param, the browser does interpret as a URL change and triggers the
// reload. It's a hacky way but, hey, this is an one-line change cross-browser solution!
const BASE_SERVICE_URL = `../instructor/serviceCatalog.html?r=${randomString()}#`;

export const makeConnectionAppointment = (connectionId, sectionId) =>
  (getTenantConfig('MOBILE_APPOINTMENTS_ENABLED')
    ? `${BASE_SERVICE_URL}/connection/${connectionId}/schedule`
    : `../appointments/appointments.html?instuid=${connectionId}&mode=makeAppointment${sectionId ? `&sectionId=${sectionId}` : ''}`);

export const makeServiceAppointment = (serviceId, sectionId) =>
  (getTenantConfig('MOBILE_APPOINTMENTS_ENABLED')
    ? `${BASE_SERVICE_URL}/service/${serviceId}/schedule${sectionId ? `?sectionId=${sectionId}` : ''}`
    : `../appointments/signup.html?partyId=${serviceId}${sectionId ? `&sectionId=${sectionId}` : ''}`);

const getServerURL = url => url.replace(/#.*/, '');

const toAbsoluteURL = url => {
  const urlResolverLink = document.createElement('a');
  urlResolverLink.href = url;
  return urlResolverLink.href;
};

export const forceNavigateTo = newPageURL => {
  const priorPageAbsoluteURL = window.location.href.toString();
  const newPageAbsoluteURL = toAbsoluteURL(newPageURL);
  window.location.href = newPageURL;
  if (getServerURL(newPageAbsoluteURL) === getServerURL(priorPageAbsoluteURL)) {
    window.location.reload();
  }
};
